<style lang="scss" scoped>
.back_form {
  &-key {
    font-size: 16px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #262626;
    padding: 25px 55px;
    line-height: 22px;
    &_m {
      color: #e62412;
    }
  }
  &-input {
    margin-top: 8px;
    margin-bottom: 16px;
  }
  .input-m {
  }
}
.URLBox {
  display: flex;
  min-height: 48px;
  line-height: 44px;
  .URL {
    width: 100%;
    margin-right: 16px;
    background: #f2fbff;
    border-radius: 4px;
    padding: 0 15px;
    min-width: 600px;
    border: 1px solid #ccecff;
  }
}
</style>
<template>
  <div>
    <FormHead style="margin-top:50px" />
    <BtnBar
      style="margin-top:150px"
      title="第一步、关联云店小程序应用"
      desc="下一步，代开发授权添加"
    />        
    <!-- 一 -->
    <Block
      :title="block1.title"
      :desc="block1.desc"
      :images="block1.images"
    >
      <template
        v-slot:form
        class="back_form"
      >
        <!-- <div class="back_form-key">
          <div class="back_form-input">
            <div class="URLBox">
              <div class="URL">
                <div>1.打开「应用管理」，在「自建」下点击「创建应用」。</div>
              </div>
            </div>
          </div>
          
        </div> -->
      </template>
    </Block>
    <!-- 二 -->
    <Block
      :title="block2.title"
      :desc="block2.desc"
      :images="block2.images"
    />
    <!-- 三 -->
    <!-- <Block
      :title="block3.title"
      :desc="block3.desc"
      :images="block3.images"
    >
      <template
        v-slot:form
        class="back_form"
      >
        <div
          class="back_form-key"
          style="padding-bottom: 0"
        >
          <span class="back_form-key_m"> * </span>企业ID：<i style="font-size:12px">我的企业-企业信息中查看</i>
          <div class="back_form-input">
            <el-input
              v-model="form.corpid"
              placeholder="请输入企业ID"
              class="m-r-6"
              clearable
              @input="formInput('corpid')"
            />
          </div>
        </div>
        <div
          class="back_form-key"
          style="padding-bottom: 0"
        >
          <span class="back_form-key_m"> * </span>AgentID：
          <div class="back_form-input">
            <el-input
              v-model="form.agent_id"
              placeholder="请输入AgentID"
              class="m-r-6"
              clearable
              @input="formInput('agent_id')"
            />
          </div>
        </div>
        <div
          class="back_form-key"
          style="padding-bottom: 0"
        >
          <span class="back_form-key_m"> * </span>Secret：
          <div class="back_form-input">
            <el-input
              v-model="form.secret"
              placeholder="请输入Secret"
              class="m-r-6"
              clearable
              @input="formInput('secret')"
            />
          </div>
        </div>
      </template>
    </Block> -->

    <BtnBar
      title="第一步、关联云店小程序应用"
      desc="下一步，代开发授权添加"
      style="margin-top: 0"
    />
    <FootBar />
  </div>
</template>

<script>
import FormHead from './comps/form/head'
import Block from './comps/form/block'
import FootBar from './comps/form/footBar'
import BtnBar from './comps/form/btnBar'
import { mapGetters } from 'vuex'
import { QWUpdateConfig } from '@/api/qwAuth'
import { setOpenworkwechat, getInitInfo } from '@/api/qwAuth'

export default {
  components: {
    FormHead,
    Block,
    FootBar,
    BtnBar
  },
  data () {
    return {
      qrcode:'',
      form: {
        aes_key: null,
        secret: null,
        token: null,
        corpid:null,
      },      
      block1: {
        title: `一、创建应用`,
        desc: '1.打开「应用管理」，在「自建」下点击「创建应用」。',
        images: require(`@/assets/img/qwLogin/info/1-1.png`)
      },
      block2: {
        title: `二、小程序授权`,
        desc: '2.点击页面下方的「已有小程序快速创建」按钮，打开小程序授权页面，使用云店小程序管理员的微信扫描页面二维码授权。',
        images: require(`@/assets/img/qwLogin/info/1-2.png`)
      },
      block3: {
        title: `三、设置授权信息`,
        desc: `3.关联成功后，先填入企业ID，再将应用详情页的「AgentId」「Secret」填入，点击Secret后的「查看」按钮会以企业微信通知的形式将该Secret发送至当前
        登录的管理员账号的企业微信`,
        images: require(`@/assets/img/qwLogin/info/1-3.png`)
      }
    }
  },
  
  computed: {
    ...mapGetters(['companyConfig'])
  },
  mounted () {
    this.init()    
  },
  methods: {
    onCopy () {
      this.$message({
        message: '复制成功',
        type: 'success'
      })
    },
    subConfig () {
      this.$store.commit('SETCompanyConifg', { key: 'external_contact', val: this.form })
      
      this.subsetOpenworkwechat()
    },

    formInput (key) {
      // console.log(key,this.form[key])
    },
    //设置部分配置详情
    subsetOpenworkwechat () {
      let params = {
        //备注: 企业ID
        corpid:this.companyConfig.external_contact.corpid,
        //备注: 外部联系人管理的信息配置
        external_contact: this.companyConfig.external_contact,
        //备注: 通讯录的信息配置
        contacts: this.companyConfig.external_contact
      }
      console.log('设置部分配置详情', params)
      try {
        // setOpenworkwechat(params).then((res) => {
        //   console.log('设置部分配置详情', res)
        //   if (res.status) {
        //     this.$message({
        //       message: '提交成功',
        //       type: 'success'
        //     })
        //     this.$router.push({ path: '/qwAuth/configApp' })            
        //   }
        // })
        this.$router.push({ path: '/qwAuth/configApp' })
      } catch (error) {
        console.log('设置部分配置详情-error', error)
      }
    },
    async init () {
      console.log('初始化企业配置项', this.companyConfig)
      this.form = this.companyConfig.external_contact
    }
  }
}
</script>
